import { useState } from "react";

import { ChevronRight } from "components/icons/generated";
import Box from "ds/components/Box";
import ButtonIcon from "ds/components/ButtonIcon";
import DropdownMenu from "ds/components/DropdownMenu";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import Toggle from "ds/components/Toggle";

import { SELECT_ALL_OPTIONS } from "../constants";

type StackRunsSelectAllDropdownProps = {
  isSelected: boolean;
  isIndeterminate: boolean;
  onToggle: () => void;
  onSelectOption: (optionId: string) => void;
};

const StackRunsSelectAllDropdown = ({
  isSelected,
  isIndeterminate,
  onToggle,
  onSelectOption,
}: StackRunsSelectAllDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const defaultToggleText = SELECT_ALL_OPTIONS[0].title;

  return (
    <Box align="center" gap="small">
      <Toggle
        isIndeterminate={isIndeterminate}
        variant="checkbox"
        aria-label="Select runs"
        isSelected={isSelected}
        tooltip={(isSelected) => (isSelected ? "Unselect all runs" : defaultToggleText)}
        onChange={onToggle}
      />
      <DropdownMenu
        onOpenChange={setIsOpen}
        isOpen={isOpen}
        triggerComponent={
          <ButtonIcon iconRotate={isOpen ? "270" : "90"} icon={ChevronRight} variant="ghost">
            {defaultToggleText}
          </ButtonIcon>
        }
      >
        {SELECT_ALL_OPTIONS.map(({ id, title }) => (
          <DropdownMenuItem
            key={id}
            onAction={() => {
              onSelectOption(id);
              setIsOpen(false);
            }}
          >
            {title}
          </DropdownMenuItem>
        ))}
      </DropdownMenu>
    </Box>
  );
};

export default StackRunsSelectAllDropdown;
